import { __awaiter } from "tslib";
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { SCol, SRow } from '@avalara/skylab-sdk/react';
import { isBillingContactUnchanged as checkIsBillingContactUnchanged, isBillingContactFormValid as checkIsBillingContactFormValid, } from '../../reducers/billingContact';
import { resetBillingContactEditForm, updateBillingContactEditForm, showBillingContactValidationErrors, setBillingContactValidatedAddress, } from '../../store/billing-contact';
import { createBillingContact, validateBillingContactForm } from '../../lib/side-effects/billing-contact';
import Address from './address';
import Contact from './contact';
import AddressValidationDialog from '../shared/address-validation';
import { selectState } from '../../selectors';
import { getCountries, resolveAddress } from '../../lib/side-effects/avatax';
import { Pages } from '../../../shared/types/offers';
import { goToNextOfferStep } from '../../lib/side-effects/offer-flow';
import { setCurrentOfferPage } from '../../store/offer';
const extractAddressFromBillingContact = (billingContactEditForm) => ({
    line1: billingContactEditForm.Address1 || '',
    line2: billingContactEditForm.Address2 || '',
    line3: '',
    city: billingContactEditForm.City || '',
    postalCode: billingContactEditForm.PostalCode || '',
    country: billingContactEditForm.Country || '',
    region: billingContactEditForm.State || '',
});
export const formatBillingContactAddressFromAddress = (address) => ({
    Address1: address.line1,
    Address2: address.line2,
    City: address.city,
    PostalCode: address.postalCode,
    Country: address.country,
    State: address.region,
});
const ContactInfo = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { billingContact, account } = useSelector(selectState);
    const { isAdmin, accountId, customerAccountId } = account;
    const [fetchingResolveAddresses, setfetchingResolveAddresses] = useState(true);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [responseAddresses, setResponseAddresses] = useState({
        address: {
            line1: '',
            line2: '',
            line3: '',
            city: '',
            region: '',
            country: '',
            postalCode: '',
        },
        validatedAddresses: [
            {
                addressType: '',
                line1: '',
                line2: '',
                line3: '',
                city: '',
                region: '',
                country: '',
                postalCode: '',
                latitude: 0,
                longitude: 0,
            },
        ],
    });
    const { billingContactEditForm, showValidationErrors, validationErrors } = billingContact;
    const isBillingContactFormValid = checkIsBillingContactFormValid(billingContact);
    const isBillingContactUnchanged = checkIsBillingContactUnchanged(billingContact);
    useEffect(() => () => {
        dispatch(resetBillingContactEditForm());
    }, []);
    useEffect(() => {
        dispatch(setCurrentOfferPage(Pages.AddBillingContact));
        dispatch(getCountries());
    }, []);
    const onUpdateFormField = (field, data) => {
        dispatch(updateBillingContactEditForm({ field, data }));
        dispatch(validateBillingContactForm());
    };
    const toggleDialog = () => {
        setDialogVisible(() => !dialogVisible);
    };
    const validateAddress = () => __awaiter(void 0, void 0, void 0, function* () {
        toggleDialog();
        const userInputAddress = extractAddressFromBillingContact(billingContactEditForm);
        const resolvedAddressResponse = yield resolveAddress(userInputAddress, dispatch);
        if (!resolvedAddressResponse.ok)
            return;
        setResponseAddresses({
            address: userInputAddress,
            validatedAddresses: resolvedAddressResponse.value.validatedAddresses,
        });
        setfetchingResolveAddresses(false);
    });
    const saveBillingContact = () => {
        dispatch(createBillingContact({
            accountId,
            customerAccountId: customerAccountId || '',
            billingContactData: billingContactEditForm,
        }));
        dispatch(goToNextOfferStep({ history }));
    };
    const handleNextClick = () => __awaiter(void 0, void 0, void 0, function* () {
        dispatch(showBillingContactValidationErrors());
        if (isBillingContactFormValid) {
            yield validateAddress();
        }
    });
    const cancelDisabled = isBillingContactUnchanged;
    const saveDisabled = !isAdmin || cancelDisabled;
    return (React.createElement(React.Fragment, null,
        React.createElement(SRow, { class: "pad-bottom-md" },
            React.createElement(SCol, { class: "pad-bottom-none" },
                React.createElement(Contact, { billingContactEditForm: billingContactEditForm, isAdmin: isAdmin, onUpdateFormField: onUpdateFormField, showValidationErrors: showValidationErrors, validationErrors: validationErrors }))),
        React.createElement(SRow, null,
            React.createElement(SCol, null,
                React.createElement(Address, { billingContactEditForm: billingContactEditForm, isAdmin: isAdmin, onUpdateFormField: onUpdateFormField, showValidationErrors: showValidationErrors, validationErrors: validationErrors }))),
        React.createElement("hr", null),
        React.createElement(SRow, null,
            React.createElement(SCol, { class: "pad-top-sm" },
                !fetchingResolveAddresses && (React.createElement(AddressValidationDialog, { responseAddresses: responseAddresses, dialogVisible: dialogVisible, setDialogVisible: toggleDialog, setPresetAddress: (address) => {
                        const formattedAddress = formatBillingContactAddressFromAddress(address);
                        dispatch(setBillingContactValidatedAddress({ data: formattedAddress }));
                        saveBillingContact();
                    } })),
                React.createElement("button", { className: "primary large", "data-ref": "buydot.contact-info.submit-button", disabled: saveDisabled, onClick: saveDisabled ? undefined : handleNextClick }, "Next"),
                React.createElement("button", { className: "secondary large", "data-ref": "buydot.contact-info.back-button", disabled: cancelDisabled, onClick: isBillingContactUnchanged ? undefined : () => dispatch(resetBillingContactEditForm()) }, "Back")))));
};
export default ContactInfo;
